export const safeJSONParse = (
  value: string | undefined,
): Record<string, unknown> => {
  if (!value) {
    return {};
  }

  try {
    return JSON.parse(value);
  } catch {
    return {};
  }
};
